import { useState, useCallback, useEffect } from 'react';
import Tooltip from 'rc-tooltip';
import debounce from 'lodash/debounce';

const TextOverflowTooltip = props => {
    const [hoverStatus, setHover] = useState(false);
    const [childNode, setChildNode] = useState(null);
    const measuredRef = useCallback(node => {
        if (node) {
            setChildNode(node);
        }
    }, []);

    useEffect(() => {
        let resizeObserver = null;
        if (childNode) {
            const observeFunction = () => {
                setHover(childNode.scrollWidth > childNode.clientWidth);
            };
            resizeObserver = new ResizeObserver(debounce(observeFunction, 300)).observe(childNode);
        }
        
        return () => {
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
        }
    }, [childNode])

    return (
        <Tooltip
            placement="top"
            trigger={hoverStatus ? ['hover'] : []}
            overlay={<span>{props.title}</span>}
        >
            {props.renderChildren(measuredRef)}
        </Tooltip>
    );
};

export default TextOverflowTooltip;
